import { useState } from "react";

// Official COLTURE wordmark (unaltered JPEG). The source art is a centered
// wordmark on a black square with wide margins, so we crop tightly to the
// lettering with CSS (container clips an over-scaled, absolutely-positioned
// img) and use mix-blend-mode:screen so the black field dissolves into the
// charcoal theme — leaving crisp white letters + the red "O".
const LOGO_SRC = "/brand/colture-official.jpg";

// Tight crop of the wordmark within the 500×500 source (measured bbox + pad).
const CROP = {
  aspectRatio: "359 / 65",
  width: "139.3%",
  height: "769.2%",
  left: "-19.5%",
  top: "-335.4%",
};

export function Brand({
  logoHeight = "h-8",
  mediaSize = "text-[11px]",
  align = "left",
  className = "",
}) {
  const [ok, setOk] = useState(true);
  const alignItems = align === "center" ? "items-center" : "items-start";
  const textAlign = align === "center" ? "text-center" : "text-left";

  if (!ok) {
    return (
      <span className={`inline-flex flex-col ${alignItems} ${className}`} data-testid="brand-header">
        <span className="font-display text-xl tracking-tight">
          COLTURE<span className="text-[#E11D2A]">.</span>
        </span>
        <span className={`mt-0.5 font-semibold tracking-[0.3em] text-white ${mediaSize}`}>Media</span>
      </span>
    );
  }

  return (
    <span className={`inline-flex flex-col ${alignItems} ${className}`} data-testid="brand-header">
      <span className={`relative block overflow-hidden ${logoHeight}`} style={{ aspectRatio: CROP.aspectRatio }}>
        <img
          src={LOGO_SRC}
          alt="Colture Media Films"
          onError={() => setOk(false)}
          draggable={false}
          className="absolute select-none"
          style={{
            width: CROP.width,
            height: CROP.height,
            left: CROP.left,
            top: CROP.top,
            maxWidth: "none",
            mixBlendMode: "screen",
          }}
        />
      </span>
      <span className={`mt-1 font-semibold tracking-[0.3em] text-white ${mediaSize} ${textAlign}`}>Media</span>
    </span>
  );
}
